// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Te4i1","colBig":"styles_colBig__3JT2m","colSmall":"styles_colSmall__eJiO5"};